import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ResponseTerminalDto } from '../types/dtos';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<ResponseTerminalDto, string>({
        query: (id) => `${APP_ENDPOINTS.TERMINAL}/${id}`,
        providesTags: [{ type: 'terminal', id: 'GET-ID' }],
    });
